import { Link } from "react-router-dom";
import { useI18n } from "../context/I18nContext";

// Reusable trust-bar shown on Paywall + Welcome + Register.  The single most
// important conversion lever for a brand-new paid site is showing the visitor
// that the actual card form is hosted by Stripe — not by us.
export default function TrustBadges({ variant = "light" }) {
  const { t } = useI18n();
  const dark = variant === "dark";
  return (
    <div
      className={`border-2 ${dark ? "border-white text-white" : "border-black text-black bg-white"} p-5 sm:p-6`}
      data-testid="trust-badges"
    >
      <div className="flex items-center gap-3">
        <svg viewBox="0 0 24 24" className="w-6 h-6 shrink-0" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          <path d="M9 12l2 2 4-4" />
        </svg>
        <div className={`font-mono-civic text-xs uppercase tracking-[0.3em] ${dark ? "text-[#FF5252]" : "text-[#E00000]"}`} style={{ fontWeight: 900 }}>
          {t("trust_eyebrow")}
        </div>
      </div>
      <div className="mt-3 font-serif-display text-2xl sm:text-3xl leading-tight" style={{ fontWeight: 800 }} data-testid="trust-headline">
        {t("trust_headline")}
      </div>
      <ul className="mt-4 space-y-2 text-sm" style={{ fontWeight: 700 }}>
        <li className="flex items-start gap-3" data-testid="trust-point-1">
          <span className={dark ? "text-[#FF5252] mt-0.5" : "text-[#E00000] mt-0.5"}>▸</span>
          <span>{t("trust_point_1")}</span>
        </li>
        <li className="flex items-start gap-3" data-testid="trust-point-2">
          <span className={dark ? "text-[#FF5252] mt-0.5" : "text-[#E00000] mt-0.5"}>▸</span>
          <span>{t("trust_point_2")}</span>
        </li>
        <li className="flex items-start gap-3" data-testid="trust-point-3">
          <span className={dark ? "text-[#FF5252] mt-0.5" : "text-[#E00000] mt-0.5"}>▸</span>
          <span>{t("trust_point_3")}</span>
        </li>
        <li className="flex items-start gap-3" data-testid="trust-point-4">
          <span className={dark ? "text-[#FF5252] mt-0.5" : "text-[#E00000] mt-0.5"}>▸</span>
          <span>{t("trust_point_4")}</span>
        </li>
      </ul>
      <div className={`mt-5 pt-4 border-t ${dark ? "border-white/30" : "border-black/20"} flex items-center justify-between gap-4 flex-wrap`}>
        <div className={`font-mono-civic text-[10px] uppercase tracking-widest ${dark ? "text-white/70" : "text-black/60"}`} style={{ fontWeight: 800 }}>
          {t("trust_powered_by")}
        </div>
        <Link
          to="/security"
          className={`font-mono-civic text-[10px] uppercase tracking-widest underline ${dark ? "hover:text-[#FF5252]" : "hover:text-[#E00000]"}`}
          style={{ fontWeight: 900 }}
          data-testid="trust-learn-more"
        >
          {t("trust_learn_more")} →
        </Link>
      </div>
    </div>
  );
}
